import { Action } from 'helpers/action-helpers';
import { User } from 'types/user';
import { Guid } from 'types/guid';

export const PROCESS_USER = 'ProcessUserAction';
export const LOAD_USER = 'LoadingUserAction';
export const LOAD_USERS = 'LoadingUsersListAction';
export const GET_USER = 'GetUserAction';
export const SET_USER = 'SetUserAction';
export const SAVE_USER = 'SaveUserAction';
export const SCAN_USER_BARCODE = 'ScanUserBarcodeAction';
export const USER_ERROR = 'UserErrorAction';
export const DELETE_USER_ERROR = 'DeleteUserErrorAction';
export const RESET_PASSWORD_ACTION = 'ResetPasswordAction';
export const RESET_PASSWORD_COMPLETE_ACTION = 'ResetPasswordCompleteAction';
export const RESET_PASSWORD_ERROR_ACTION = 'ResetPasswordErrorAction';
export const ACTIVATE_USER = 'ActivateUserAction';
export const DEACTIVATE_USER = 'DeactivateUserAction';
export const SET_REQUEST_STATUS = 'SetRequestStatus';

export class LoadUserAction extends Action {
  constructor() {
    super(LOAD_USER);
  }
}

export class LoadUsersListAction extends Action {
  constructor() {
    super(LOAD_USERS);
  }
}

export class ProcessUserAction extends Action {
  constructor() {
    super(PROCESS_USER);
  }
}

export class GetUserAction extends Action {
  constructor(public userId: Guid) {
    super(GET_USER);
  }
}
export class SetUserAction extends Action {
  constructor(public user: User) {
    super(SET_USER);
  }
}

export class SaveUserAction extends Action {
  constructor(public userId: Guid, public user: User) {
    super(SAVE_USER);
  }
}

export class ScanUserBarcodeAction extends Action {
  constructor(public barcode: string) {
    super(SCAN_USER_BARCODE);
  }
}

export class UserManagementErrorAction extends Action {
  constructor(public errorMessage: string) {
    super(USER_ERROR);
  }
}

export class ResetPasswordAction extends Action {
  constructor(public userEmail: string) {
    super(RESET_PASSWORD_ACTION);
  }
}

export class ResetPasswordCompleteAction extends Action {
  constructor() {
    super(RESET_PASSWORD_COMPLETE_ACTION);
  }
}

export class ResetPasswordErrorAction extends Action {
  constructor(public message: string) {
    super(RESET_PASSWORD_ERROR_ACTION);
  }
}

export class ActivateUserAction extends Action {
  constructor(public userId: Guid) {
    super(ACTIVATE_USER);
  }
}

export class DeactivateUserAction extends Action {
  constructor(public userId: Guid) {
    super(DEACTIVATE_USER);
  }
}

export class SetCreateUserStatusAction extends Action {
  constructor(public status: boolean) {
    super(SET_REQUEST_STATUS);
  }
}


// WEBPACK FOOTER //
// ./src/pages/user-management/actions.ts